"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedBy = exports.TeacherRole = exports.UserType = exports.DEFAULT_REGION = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'user-info-service';
exports.DEFAULT_REGION = 'GB';
var UserType;
(function (UserType) {
    UserType["student"] = "schoolstudent";
    UserType["teacher"] = "schoolteacher";
    UserType["parent"] = "schoolparent";
})(UserType = exports.UserType || (exports.UserType = {}));
var TeacherRole;
(function (TeacherRole) {
    TeacherRole["ClassroomTeacher"] = "classroom_teacher";
    TeacherRole["HeadOfDepartment"] = "head_department";
    TeacherRole["HeadOfYear"] = "head_year";
    TeacherRole["SeniorLeader"] = "senior_leader";
    TeacherRole["Headteacher"] = "headteacher";
    TeacherRole["NonTeachingStaff"] = "non_teaching_staff";
    TeacherRole["Other"] = "other";
})(TeacherRole = exports.TeacherRole || (exports.TeacherRole = {}));
var ManagedBy;
(function (ManagedBy) {
    ManagedBy["misSyncService"] = "misSyncService";
})(ManagedBy = exports.ManagedBy || (exports.ManagedBy = {}));
//# sourceMappingURL=index.js.map